import React from "react";
import { Card, Description, Footer, Icon, LearnMore, Title } from "./styles";
import { ArrowRight } from "lucide-react";

const ServiceCard = ({ icon, title, description }) => {
    const message = (
        `Hola, me interesa conocer más sobre el servicio de "${title}" que ofrecen. ¿Podrían brindarme más información?`
    );

    return (
        <Card>
            <Icon>{icon}</Icon>

            <Title>{title}</Title>

            <Description>{description}</Description>

            <Footer>
                <LearnMore
                    href={`https://wa.me/5213316710897?text=${message}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Saber más
                    <ArrowRight size={20}/>
                </LearnMore>
            </Footer>
        </Card>
    )
};

export default ServiceCard;